import { defineComponent as s, createBlock as a, openBlock as l, withCtx as t, createVNode as o, unref as r, createCommentVNode as i } from "vue";
import f from "../../../icons/generated/IconCross.vue2.js";
import b from "../../../icons/generated/IconDownload.vue2.js";
import m from "./DocumentSmallAvatar.vue2.js";
import p from "./DocumentSmallBase.vue2.js";
import { RevIllustration as c } from "@ds/components/Illustration";
const A = /* @__PURE__ */ s({
  name: "DocumentDefaultSmall",
  __name: "DocumentDefaultSmall",
  props: {
    name: {},
    url: {},
    deletable: { type: Boolean },
    thumbnail: { type: Boolean },
    downloadButtonAriaLabel: {},
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(B, { emit: u }) {
    const d = u;
    return (e, n) => (l(), a(p, {
      "button-attrs": {
        target: "_blank",
        to: e.url
      }
    }, {
      avatar: t(() => [
        e.url && !e.deletable ? (l(), a(m, {
          key: 0,
          "aria-label": e.downloadButtonAriaLabel,
          download: e.name,
          to: e.url
        }, {
          default: t(() => [
            o(r(b), { size: "16" })
          ]),
          _: 1
        }, 8, ["aria-label", "download", "to"])) : i("", !0),
        e.deletable ? (l(), a(m, {
          key: 1,
          "aria-label": e.deleteButtonAriaLabel,
          onClick: n[0] || (n[0] = (_) => d("delete"))
        }, {
          default: t(() => [
            o(r(f), { size: "16" })
          ]),
          _: 1
        }, 8, ["aria-label"])) : i("", !0)
      ]),
      default: t(() => [
        o(r(c), {
          alt: "",
          height: 64,
          "image-class-names": "size-64 object-cover object-center",
          src: e.url,
          title: e.name,
          width: 64
        }, null, 8, ["src", "title"])
      ]),
      _: 1
    }, 8, ["button-attrs"]));
  }
});
export {
  A as default
};
